module.exports = __webpack_public_path__ + "img/zev-education@2x.6bb05a89.webp";